var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.5 15H11v-1.5H8v-1h3V9H6.5v1.5h3v1h-3zM3 21V3h18v18zm2-2h14V5H5zm0 0V5zm8-4h4.25l.75-.75v-4.5L17.25 9H13zm1.5-1.5v-3h2v3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2D);
export default __webpack_public_path__ + "static/media/2d.e321a532be7e3d097c7fa077852aa5f4.svg";
export { ForwardRef as ReactComponent };